export default __webpack_public_path__ + "static/media/exit.4f94b215.svg";